import React from 'react';
import { useTranslation } from 'react-i18next';

import slikaIvanIAlek from '../assets/img/IvanIAlek.jpg';
import slikaDimitrijeICveta from '../assets/img/DimitrijeICveta.jpg';

const AboutUs = ({apartmentId}) => {
    const [t, i18n] = useTranslation("global");

    const descriptions = {
        '1': {
            1: t('dreamPageText.description1'),
            2: t('dreamPageText.description2'),
            3: t('dreamPageText.description3'),
            4: t('dreamPageText.description4'),
            11: t('dreamPageText.description11'),
            slika: slikaIvanIAlek
        },
        '2': {
            1: t('dcPageText.description1'),
            2: t('dcPageText.description2'),
            3: t('dcPageText.description3'),
            4: t('dcPageText.description4'),
            11: t('dcPageText.description11'),
            slika: slikaDimitrijeICveta
        }
    };

    const description = descriptions[apartmentId];

    return (
        <div className="flex items-center justify-center mb-8">
            <div className="mx-auto bg-white shadow-md rounded-lg">
                <div className="p-4">
                    <div className="uppercase tracking-wide text-sm text-gray-800 font-semibold text-center mb-4">{description[11]}</div>
                    <div>
                        <img className="h-24 w-24 rounded-full object-cover mx-auto mb-4" src={description.slika} alt="About Us" />
                    </div>
                    {Object.values(description).slice(0, -2).map((desc, index) => (
                        <p key={index} className="text-gray-600 mb-4 text-center">{desc}</p>
                    ))}
                </div>
            </div>
        </div>
    );
}

export default AboutUs;
